import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { translate } from "../keys/localStorageKeys";

import en from '../locales/en/translation.json';
import zh from '../locales/zh/translation.json';
import es from '../locales/es/translation.json';
import id from '../locales/id/translation.json';
import th from '../locales/th/translation.json';

const resources = {
  en: { translation: en },
  zh: { translation: zh },
  es: { translation: es },
  id: { translation: id },
  th: { translation: th },
};

i18n.use(initReactI18next).init({
    lng: localStorage.getItem(translate) ?? navigator.language?.slice(0, 2) ?? 'en',
    supportedLngs: ["en", "id", "zh", "th", "es"],
    fallbackLng: "en",
    resources: resources,
    react: {useSuspense: false},
    interpolation: {
        escapeValue: false,
    }
})

export default i18n;